import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { Link } from "react-router-dom";

import logo from "@/assets/logo_noborder.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setSuccessMessage("Password reset email sent. Please check your inbox.");
      setErrorMessage("");
    } catch (error) {
      setSuccessMessage("");
      setErrorMessage("Failed to send password reset email. Please try again.");
    }
  };

  return (
    <div className="bg-grid flex min-h-[100vh] flex-col justify-center px-4 py-12 text-fg sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img className="mx-auto h-16 w-auto drop-shadow-[0_0_16px_rgb(var(--primary)/0.45)]" src={logo} alt="SpeechCraft" />
        <h2 className="mt-6 text-center font-display text-3xl font-bold uppercase leading-9 tracking-[0.08em] text-fg">
          Reset Password
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
        <div className="panel rounded-lg px-6 py-10 shadow-panel sm:px-10">
          {successMessage && (
            <div className="mb-4 rounded border border-primary/40 bg-primary/10 p-4 text-primary">
              {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="mb-4 rounded border border-danger/40 bg-danger/10 p-4 text-danger">
              {errorMessage}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="hud-label block"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded border border-line bg-elevated px-3 py-2.5 text-fg placeholder:text-fg-subtle transition focus:border-primary/70 focus:outline-none focus:ring-1 focus:ring-primary/40 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded border border-primary bg-primary px-3 py-2 font-display text-sm font-semibold uppercase leading-6 tracking-[0.18em] text-primary-fg transition hover:bg-primary-strong hover:shadow-glow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:opacity-50"
              >
                Reset Password
              </button>
            </div>
          </form>

          <p className="mt-8 text-center text-sm text-fg-muted">
            Remember your password?{" "}
            <Link
              to="/login"
              className="leading-6 font-semibold text-primary transition hover:text-primary-strong"
            >
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;